// extracted by mini-css-extract-plugin
module.exports = {"featureItem":"FeatureTag_featureItem__HU_VC","featureText":"FeatureTag_featureText__CuxVd"};